import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Notebook14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M3.75 1.75H8V0.25H3.375C2.7388 0.25 2.25 0.809302 2.25 1.42857V2.75H1V4.25H2.25V6.25H1V7.75H2.25V9.75H1V11.25H2.25V12.5714C2.25 13.1907 2.7388 13.75 3.375 13.75H11.625C12.2612 13.75 12.75 13.1907 12.75 12.5714V7H11.25V12.25H3.75V11.25H4.5V9.75H3.75V7.75H4.5V6.25H3.75V4.25H4.5V2.75H3.75V1.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.8839 0.823209C11.3957 0.335053 10.6043 0.335054 10.1161 0.823209L6.30908 4.63023L5.83809 6.98518C5.69815 7.6849 6.31506 8.30182 7.01479 8.16188L9.36974 7.69089L13.1768 3.88387C13.6649 3.39571 13.6649 2.60426 13.1768 2.1161L11.8839 0.823209ZM7.69088 5.36974L11 2.06065L11.9393 2.99999L8.63022 6.30908L7.45605 6.54392L7.69088 5.36974Z'
      fill='currentColor'
    />
  </Svg>
);

Notebook14.displayName = 'Notebook14';
export default Notebook14;
